<template>
  <div>
    <ts-dialog title="Add a filestage project" :visible.sync="visible" width="500px" center :show-close="false">
      <div v-for="(v, index) in $v.form.steps.$each.$iter" :key="index">
        <ts-form-item :validation="v.name">
          <ts-input placeholder="Filestage Name" v-model.lazy="v.name.$model"></ts-input>
        </ts-form-item>
        <ts-form-item :validation="v.url">
          <ts-input placeholder="Link" v-model.lazy="v.url.$model"></ts-input>
        </ts-form-item>
      </div>
      <span slot="footer">
        <div class="footer">
          <ts-button @click="handleSaveClick">Create</ts-button>
        </div>
      </span>
    </ts-dialog>
    <ts-button size="small" @click="handleOpenPickerButtonClick">Add your filestage project</ts-button>
  </div>
</template>

<style lang="scss" scoped>
.user-picker {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;

  .label {
    font-family: Roboto;
    font-size: 16px;
    color: #000000;

    margin-right: 20px;
  }
}

.footer {
  padding-top: 12px;
}
</style>

<script>
import { required, url } from 'vuelidate/lib/validators';

import UserPicker from '@/components/inputs/UserPicker.vue';

export default {
  components: {
    UserPicker
  },
  props: {
    users: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      form: {
        steps: [
          {
            name: '',
            url: '',
            users: []
          }
        ]
      }
    };
  },
  validations: {
    form: {
      steps: {
        $each: {
          name: {
            required
          },
          url: {
            required,
            url
          },
          users: {}
        }
      }
    }
  },
  methods: {
    handleAddStepClick() {
      this.form.steps = [
        ...this.form.steps,
        {
          name: '',
          url: '',
          users: []
        }
      ];
    },
    handleSaveClick() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit('input', this.form.steps);
        this.visible = false;
        this.resetForm();
      }
    },
    handleOpenPickerButtonClick() {
      this.resetForm();
      this.visible = true;
    },
    resetForm() {
      this.form.steps = [
        {
          name: '',
          url: '',
          users: []
        }
      ];
      this.$v.$reset();
    }
  }
};
</script>
